import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  icon: "build",
  contractors: [],
  contractor: {},
  regions: [],
  region: {},
  contacts: [],
  contact: {},
  contractorRegionDropdownOptions: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
